import { css } from "@emotion/react";



export const CreativeCommonStyle = css`

    display: flex;
    justify-content: flex-end;

    a{
        &:hover{
            img{ 
                transform: rotate(20deg);
                &:last-child{
                    transform: rotate(-20deg);
                }
            }
        }
        img{
            margin-left: 3px;
            display: inline-block;
            width: 33px;
            
        }
    }




`